import { useEffect } from 'react';
import { generatePath, useLoaderData, useLocation, useNavigate, useRouteLoaderData } from 'react-router';
import { paths } from '../../../../../common/constants/pathVariables';
import { SubscriptionCategory } from '../../../../../common/enums.js';
import { getSubscriptionUrlId } from '../../../../../common/utils/subscriptionUtils';
import { AttachVakio } from '../../../../../components/AttachVakio/AttachVakio';
import type { MobileSubAttachVakioLoaderData, MobileSubscriptionLoaderResponse } from '../../../../../common/loaders';
import type { AssociationRecord } from '../../../../../legacy/cloudsense-add-on-dependency-engine/AddOnManagerOnline';

export const MobileSubAttachVakioPath = () => {
  const { companyInfo, hasPendingActions, subscription, numberRanges } =
    useLoaderData() as MobileSubAttachVakioLoaderData;
  const navigate = useNavigate();
  const { search } = useLocation();
  const { addOnRules } = useRouteLoaderData('voiceSub') as MobileSubscriptionLoaderResponse;
  const addOnAssociations = (addOnRules?.associations?.[0] as AssociationRecord[]) ?? [];

  useEffect(() => {
    if (hasPendingActions) {
      navigate(
        generatePath(paths.PS_MOBILE_SUBSCRIPTION, { subscriptionId: getSubscriptionUrlId(subscription) }) + search,
        {
          replace: true,
        }
      );
    }
  }, [navigate, search, subscription, hasPendingActions]);

  return (
    <AttachVakio
      category={SubscriptionCategory.VOICE}
      companyInfo={companyInfo}
      subscription={subscription}
      numberRanges={numberRanges}
      addOnAssociations={addOnAssociations}
    />
  );
};
